export type KeyDataSearch =
  | 'number_of_adults'
  | 'number_of_preschoolers'
  | 'number_of_students'
  | 'number_of_preschoolers_1'
  | 'number_of_students_1'
  | 'stay_day'
  | 'start_date'
  | 'preschooler_birthdays'

export type PreschoolerBirthdays = {
  year: string
  month: string
  day: string
}

export type DataSearchType = {
  number_of_adults: number
  number_of_preschoolers: number
  number_of_students: number
  number_of_preschoolers_1: number
  number_of_students_1: number
  preschooler_birthdays: PreschoolerBirthdays[]
  stay_day: string
  start_date: string
  select_month: string
}

const serviceTypes = JSON.parse(
  (document.querySelector('[data-service-types]') as HTMLElement)?.dataset?.serviceTypes || '[]',
) as string[]
export const DATA_SEARCH_INIT: DataSearchType = {
  number_of_adults: 2,
  number_of_preschoolers: serviceTypes.some((serviceType) => serviceType.includes('保育園留学')) ? 1 : 0,
  number_of_students: serviceTypes.every((serviceType) => serviceType === '小学生留学') ? 1 : 0,
  number_of_preschoolers_1: 0,
  number_of_students_1: 0,
  preschooler_birthdays: [
    {
      year: '',
      month: '',
      day: '',
    },
  ],
  stay_day: '7',
  start_date: undefined,
  select_month: undefined,
}

export const searchData: DataSearchType = {
  ...DATA_SEARCH_INIT,
  preschooler_birthdays: [
    {
      year: '',
      month: '',
      day: '',
    },
  ],
}

export type RoomType = {
  id: number
  name: string
  roomType: string
  description: string | null
  roomMaxCount: number
  kitchen: string | null
  bedroom: string[]
  bathroom: string[]
  laundry: string | null
  foodText: string | null
  roomEnvironment: string[]
  accessFromGuesthouseToNursery: string | null
  conditionsForRemoteWork: string | null
  images: string[]
  floorImages: string[]
}

export type CheckInDateType = {
  date: string // ISO date format (YYYY-MM-DD)
  endDate: string
  status: 'OK' | 'NG' | '-'
  price: number | null
  stayDay: number
}

export type PlanType = {
  planId: number
  mainNurseryName: string
  mainNurseryFirstFeatureImageUrl: string
  subNurseryName: string | null
  subNurseryFirstFeatureImageUrl: string | null
  room: RoomType
  order: number
  checkInDates: CheckInDateType[]
}
